if (!customElements.get('salon-tabs')) {
  customElements.define('salon-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.activate(next);
          this.tabs[next].focus();
        });
      });
    }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active);
        tab.tabIndex = active ? 0 : -1;
        this.panels[i].hidden = !active;
      });
    }
  });
}
